export default "__VITE_ASSET__c684ff4e__"